interface OpenIconProps {
  onClick: () => void;
}
export default function OpenIcon({onClick}: OpenIconProps) {
  return (
    <svg onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      fill="none"
      viewBox="0 0 30 30"
    >
      <path
        fill="#333"
        d="M7 7.642v14.716a.64.64 0 00.642.642h14.716a.64.64 0 00.642-.642v-7.196c0-.09-.07-.16-.16-.16h-1.119c-.09 0-.16.07-.16.16v6.4H8.439V8.438h6.4c.09 0 .16-.07.16-.159v-1.12c0-.09-.07-.159-.16-.159H7.642A.637.637 0 007 7.642zm12.223 1.881l-1.369-1.368a.126.126 0 01.075-.214l4.514-.528c.08-.01.149.06.139.14l-.528 4.513a.125.125 0 01-.214.075l-1.358-1.359a.12.12 0 00-.174 0l-7.66 7.654a.12.12 0 01-.174 0l-.9-.9a.12.12 0 010-.175l7.659-7.659a.12.12 0 000-.174l-.01-.005z"
      ></path>
    </svg>
  );
}
